const modal_actions_suffix = Math.random().toString(36).substring(7);

export const SHOW_MODAL = `SHOW_MODAL:${modal_actions_suffix}`;
export const MODAL_CONFIRM = `MODAL_CONFIRM:${modal_actions_suffix}`;
export const MODAL_CANCEL = `MODAL_CANCEL:${modal_actions_suffix}`;
export const HIDE_MODAL = `HIDE_MODAL:${modal_actions_suffix}`;
